import { toCamelCase } from '@/modules/TCIUtils';

type Flags = {
  accessibilityReflow?: boolean;
  aiGradingActive?: boolean;
  assignmentsBasedGrading?: boolean;
  assignSlideshowVideoActivity?: boolean;
  asyncFileGeneration?: boolean;
  autoFetchTotalSlideshowScore?: boolean;
  autoplayAudio?: boolean;
  canToggleSubscriberAiLeveledReading?: boolean;
  canUseUpdatedSpeechstream?: boolean;
  correlationsFilters?: boolean;
  coTeacherAssignmentVisibility?: boolean;
  displaySlideGroupHeaders?: boolean;
  flushImageTreatment?: boolean;
  gradingFilters?: boolean;
  gulfOfAmericaMessagingEnabled?: boolean;
  gulfOfMexicoNoticeDismissed?: boolean;
  libraryReadingTools?: boolean;
  newLessonOverviewPage?: boolean;
  newUnitOverviewPage?: boolean;
  safari?: boolean;
  separateAssignNotebookReading?: boolean,
  subscriberAiReadingLevelsEnabled?: boolean;
  showAiModify?: boolean;
  showAdvancedStandards?: boolean;
  showSpeechstreamToolbar?: boolean;
  spanishDrawingQuestionTextImages?: boolean;
  sysadminCorrelationsEdit?: boolean;
  teacherPacedMode?: boolean;
  usesAssignmentsBasedGrading?: boolean;
  usesTeacherPacedMode?: boolean;
  useSpeechstreamTranslations?: boolean;
  useZoomForSlideshows?: boolean;
  scaleVocabDnd?: boolean;
  displayTextVariableButton?: boolean;
  manageProgramsClassesPage?: boolean;
  newImageMergeModal?: boolean;
  bigBookSlideshow?: boolean;
  updatedLtiOrphanedAssignmentFlow?: boolean;
};

const useFlags = () => {
  const flags = $('#slug-attributes').data('flags') as Flags;

  if (!flags) return {} as Flags;

  return toCamelCase(flags) as Flags;
};

export default useFlags;
